import React from "react";
import { Typography } from "@mui/material";

import "./style.scss";
import { t } from "i18next";

export const ErrorScreen = () => {
    return <div className={"error-boundary"}>
        <Typography variant={"h4"}>{t("components.errorScreen.title")}</Typography>
        <Typography>
            {t("components.errorScreen.description")}
        </Typography>
    </div>;
};
